import { React, Component } from 'react';
import { connect } from 'react-redux';
import moment from 'moment';
import Paper from 'material-ui/Paper';
import RaisedButton from 'material-ui/RaisedButton';
import RelationshipDialog from './RelationshipDialog';
import FlatButton from 'material-ui/FlatButton';
import CheckIcon from 'material-ui/svg-icons/action/check-circle';
import InfoBadge from './InfoBadge';

import originFields from '../../defaults/PointOfOriginFields.json';
import theme from '../../muiTheme';
import './DetailsDashboardPanel.css';

import {
  Table,
  TableBody,
  TableRow,
  TableRowColumn,
} from 'material-ui/Table';

const styles = {
  decertifyBtn: {
    height: "30px",
    lineHeight: "30px",
    fontSize: "12px"
  },
  certifiedLabel: {
    color: theme.palette.primary2Color,
    display: "flex",
    alignItems: "center"
  }
};

class DetailsDashboardPanel extends Component {

  constructor(props) {
    super(props);
    this.state = {
      showingRelationshipsDialog: false,
      relationshipDisplayPackage: null
    };
  }

  displayRelationship = (relationshipId, occurenceId) => {
    window.api.getIrwinRelationshipPackage(relationshipId, occurenceId).then(resp => {
      this.setState({
        showingRelationshipsDialog: true,
        relationshipDisplayPackage: resp
      });
    });
  }

  onCloseRelationshipDialog = () => {
    this.setState({
      showingRelationshipsDialog: false
    });
  }

  render() {
    const hasAcreageRows = (this.props.incident.perimeterAcreage && this.props.incident.perimeterAcreage.AcreageRecords && this.props.incident.perimeterAcreage.AcreageRecords.length > 0);
    const isFalseAlarm = (this.props.incident.attributes[originFields.incidentTypeCategory] && this.props.incident.attributes[originFields.incidentTypeCategory] === "FA");
    const attrs = this.props.incident.attributes;
    const relationships = this.props.irwinRelationships;
    let infoBadges = [];
    let isQuarantined = attrs[originFields.isQuarantined] === 1;

    if (relationships) {
      for (const relationship of relationships) {
        const isChild = (relationship.ChildFireOccurenceRecordID) && relationship.ChildFireOccurenceRecordID === attrs[originFields.fireOccurenceRecordID];
        const hasLinks = (relationship.ParentFireOccurenceRecordID && relationship.ChildFireOccurenceRecordID);
        let label = "";
        switch (relationship.IrwinRelationshipTypeID) {
          case 1: //ProvidingResponseTo
            label = "Providing Response";
            break;

          case 2: //Complex
            label = "Complex";
            break;

          case 3: //Conflict
            label = "Conflict";
            break;

          case 4: //Merge
            label = "Merge";
            break;

          case 5: //Prescribed Escape
            label = "Prescribed Escape";
            break;

          case 6: //Post-Fire
            label = "Post-Fire";
            break;
        }
        if (hasLinks) {
          const relLabel = (hasLinks) ? (isChild ? " - Child" : " - Parent") : "";
          infoBadges.push(
            <InfoBadge key="childBadge" style={{ color: theme.palette.accent3Color }} onClick={e => this.displayRelationship(relationship.IrwinRelationshipID, attrs[originFields.fireOccurenceRecordID])} label={label + relLabel} />);
        }
        else {
          infoBadges.push(<InfoBadge key={"childBadge" + relationship.IrwinRelationshipTypeID} style={{ color: theme.palette.accent3Color }} label={label} />);
        }
      }
    }
    let certLabel;
    let certAction;
    if (this.props.isCertified) {
      certLabel = (
        <span
          style={styles.certifiedLabel}>
          <CheckIcon color={theme.palette.primary2Color} /> Incident Is Certified
        </span>
      );
      certAction = (
        <FlatButton
          style={styles.decertifyBtn}
          labelStyle={{ fontSize: styles.decertifyBtn.fontSize }}
          secondary={true}
          backgroundColor="#ECEFF5"
          hoverColor="#D9DBE1"
          label="Decertify Incident"
          disabled={this.props.isReadOnlyUser || !this.props.auth.isCertifier}
          onClick={this.props.onDecertifyIncident} />
      )
    }
    else if (this.props.missingFieldsCount === 0) {
      certLabel = "Ready To Be Certified";
      let disableCertify = false;

      if (this.props.isFederal && this.props.isPerimeterTriangle && (this.props.incidentAcres >= 10)) {
        certLabel = "A valid perimeter is required for Federal fires > 10 acres";
        disableCertify = true;
      }

      if (!hasAcreageRows && !isFalseAlarm) {
        certLabel = "Missing Landowner acres";
        disableCertify = true;
      }

      certAction = (
        <RaisedButton
          labelColor={theme.palette.canvasColor}
          backgroundColor={theme.palette.primary2Color}
          label="Certify Incident"
          disabled={this.props.mode === "edit" || this.props.isReadOnlyUser || disableCertify || isQuarantined || !this.props.auth.isCertifier}
          onClick={this.props.onCertifyIncident} />
      )
    } else if
      (
      !this.props.incident.attributes[originFields.fireCode] && this.props.incident.attributes[originFields.isFireCodeRequested] !== originFields.isFireCodeRequested_RequestedCode) {
      certLabel = ('');
    }
    else {
      certLabel = (
        <span style={{ color: theme.palette.accent1Color }}>{this.props.missingFieldsCount} Required Fields Missing</span>
      );
      certAction = (
        <RaisedButton
          disabled={true}
          labelColor={theme.palette.canvasColor}
          backgroundColor={theme.palette.primary2Color}
          label="Certify Incident" />
      )
    }
    let fireNameVal = attrs[originFields.name];
    let fireIdVal = attrs[originFields.uniqueFireId];
    let incidentSizeVal = attrs[originFields.incidentSize];
    let discoveryDateVal = moment(attrs[originFields.discoveryDate]).format(this.props.appConfig.timeDateFormat);

    let locations = [];

    if (attrs[originFields.city]) {
      locations.push(attrs[originFields.city]);
    }
    if (attrs[originFields.state]) {
      const stateValue = attrs[originFields.state];
      const matchingInfos = this.props.appConfig.fieldInfos.filter(fieldInfo => { return (fieldInfo.name === originFields.state && fieldInfo.domain) });
      if (matchingInfos[0] && matchingInfos[0].domain.codedValues) {
        const matchingCodedValue = matchingInfos[0].domain.codedValues.filter(cv => { return cv.code === stateValue });
        locations.push((matchingCodedValue[0]) ? matchingCodedValue[0].name : stateValue);
      }
      else {
        locations.push(stateValue);
      }
    }
    if (locations.length === 0) {
      locations.push("––");
    }

    let modifiedLabel;
    const hasIrwinModifiedDate = (attrs[originFields.modifiedDate]);
    const hasInformModifiedDate = (attrs[originFields.informLastModifiedDate]);
    const irwinModifiedOnly = (hasIrwinModifiedDate && !hasInformModifiedDate);

    let modifiedBySystem = attrs[originFields.modifiedBySystem];
    if (hasIrwinModifiedDate && hasInformModifiedDate && attrs[originFields.informLastModifiedDate] > attrs[originFields.modifiedDate]) {
      modifiedBySystem = "InFORM Inspector";
    }

    const displayDate = (irwinModifiedOnly) ? moment(attrs[originFields.modifiedDate]).format(this.props.appConfig.timeDateFormat) : moment(attrs[originFields.informLastModifiedDate]).format(this.props.appConfig.timeDateFormat);

    if (attrs[originFields.modifiedDate]) {
      modifiedLabel = (
        <div className="last-update-container">
          <span>Last Modified: {displayDate} ({modifiedBySystem})</span>
        </div>
      )
    }

    return (
      <Paper className="details-dashboard-panel incident-details-panel">
        {modifiedLabel}

        <Table selectable={false} className="details-dashboard-panel-table">
          <TableBody displayRowCheckbox={false}>
            <TableRow className="details-dashboard-panel-tr">
              <TableRowColumn className="detail-row-label">NAME</TableRowColumn>
              <TableRowColumn>{fireNameVal}</TableRowColumn>
              <TableRowColumn rowSpan={3}>
                <div className="dashboard-field-group-value">
                  {certLabel}
                </div>
                <div className="dashboard-field-group-label">
                  {(!this.props.isReadOnlyUser) ? certAction : ""}
                </div>
              </TableRowColumn>
            </TableRow>
            <TableRow className="details-dashboard-panel-tr">
              <TableRowColumn className="detail-row-label">ID</TableRowColumn>
              <TableRowColumn>{fireIdVal}</TableRowColumn>
            </TableRow>
            <TableRow className="details-dashboard-panel-tr">
              <TableRowColumn className="detail-row-label">DISCOVERY DATE</TableRowColumn>
              <TableRowColumn>{discoveryDateVal}</TableRowColumn>
            </TableRow>
            <TableRow className="details-dashboard-panel-tr">
              <TableRowColumn className="detail-row-label">FIRE SIZE</TableRowColumn>
              <TableRowColumn>{incidentSizeVal}</TableRowColumn>
            </TableRow>
          </TableBody>
        </Table>

        <div className="flex-container-row">{infoBadges}</div>
        <RelationshipDialog
          open={this.state.showingRelationshipsDialog}
          displayPackage={this.state.relationshipDisplayPackage}
          onCloseRelationshipDialog={this.onCloseRelationshipDialog}
        />
      </Paper>
    );

  }

}
const mapStateToProps = state => ({
  appConfig: state.config,
  auth: state.auth
})

export default connect(mapStateToProps)(DetailsDashboardPanel)

